import { createFileRoute, redirect } from "@tanstack/react-router";

/** The bare address is the same door as the workspace switcher's Settings. */
export const Route = createFileRoute("/_authenticated/_administration/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/ws/settings", replace: true });
  },
});
